module.exports = __webpack_public_path__ + "static/media/dance.28cce565.JPG";